//import dependencies (styles, scripts)
import '../styles/output.css'
import '../styles/global.css'
//returns the Header component
let Header=()=>{
    return(
        <div className='main w-screen flex flex-row justify-end'>
            {/* Introduction section */}
            <div className='w-1/2 flex flex-row justify-start flex-shrink-0 bg-neutral-950'>
              <div className='w-full flex flex-col flex-nowrap justify-center flex-shrink-0 items-end bg-neutral-950'>
                <h2 className='text-base text-slate-200 font-bold'>Roy Clinton</h2>
                <h2 className='text-lg text-black text-nowrap font-bold bg-yellow-400 px-2 relative left-16 z-10 mobile-l:left-10'>Graphic Designer</h2>
              </div>
            </div>
            {/* Image sector */}
            <div className='w-auto'>
                <img src='/images/subject/subject02.webp' loading='lazy' alt='' className='max-h-[516px] z-0'/>
            </div>

        </div>
    )
}
export default Header;